<template lang='pug'>
  i.svg-icon.svg-icon-ios
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )

      path(d="M12.72,55.92c0-1.28,0-2.56,0-3.84c0.33-2.2,0.53-4.43,1-6.6c2.19-10.35,10.1-17.05,20.67-17.68 c3.53-0.21,6.81,0.72,10.02,2.01c2.89,1.16,5.89,2.06,8.99,1.57c2.69-0.43,5.36-1.23,7.93-2.16c7.83-2.83,14.92-1.38,21.5,3.39 c1.41,1.02,1.35,1.03-0.09,1.96c-7.49,4.87-10.95,11.77-9.7,20.63c1.16,8.18,5.84,13.74,13.73,16.43c0.89,0.3,0.92,0.64,0.6,1.34 c-1.12,2.47-2.12,5-3.35,7.41c-2.29,4.48-5.1,8.59-8.92,11.94c-2.32,2.03-4.91,3.09-8.11,2.8c-3.15-0.28-6.13-1.07-8.98-2.34 c-4.01-1.79-7.93-1.69-11.94,0.05c-1.82,0.79-3.74,1.41-5.68,1.84c-3.81,0.84-7.57,0.92-10.76-1.9c-1.14-1-2.32-1.98-3.32-3.11 c-6.74-7.62-10.67-16.6-12.59-26.51C13.23,60.76,13.04,58.33,12.72,55.92z")

      path(d="M68.88,5.28c0.32,6.04-1.84,11.17-5.85,15.57c-3.12,3.42-7.04,5.58-11.5,6.75c-1.42,0.37-1.47,0.35-1.34-1.18 c0.83-9.65,5.85-16.21,14.72-19.91c1.21-0.5,2.49-0.83,3.73-1.23C68.72,5.28,68.8,5.28,68.88,5.28z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
